<template>
  <div class="nav-mobile">
    <div class="nav-mobile__top ">
      <div class="row position-relative">
        <div class="col-4 nav-mobile__top-left">
          <button class="button button__icon button__icon--lightgrey" onclick="goBack()">
            <i class="demo-icon icon-back"></i>
          </button>
        </div>
        <div class="col-4 nav-mobile__top-center">
          <router-link :to="{ name: 'members' }">
            <slot name="rooms-header-logo"></slot>
          </router-link>
        </div>
        <div class="col-4 nav-mobile__top-right">
          <router-link
            v-if="user"
            :to="{ name: 'payment', params: { unit: 'credits' }}"
            class="nav-mobile__coins-button"
          >
            <p class="card-points__points">
              {{ user.coins + user.free_coins }}
              <i class="demo-icon icon-n-lova-coins"></i>
            </p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'ChatRoomMobileMenu',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  methods: {},
  mounted() {

  }
};
</script>
